<!-- {{data.message}} -->
<div class="d-flex align-items-center" *ngIf="button">
    <div class="lh28">{{ data.message }}</div>
    <button mat-button class="ml-auto btn-sm" (click)="dismiss()">
        <ion-icon name="close-outline"></ion-icon>
    </button>
</div>
<div class="text-center" *ngIf="!button">
    <div class="lh28">{{ data.message }}</div>
</div>